module.exports = __webpack_public_path__ + "resources/img/img_secureguard_pm4_en.f7fd6a415ba32b694204c6095eb292d9.png";